import { appliancesConstants } from "../_constants";

export function appliances(
  state = {
    fetchingDetail: false,
    tab: "used",
    detail: {},
    detailItem: 0
  },
  action
) {
  switch (action.type) {
    case appliancesConstants.DETAIL_REQUEST:
      return {
        ...state,
        fetchingDetail: true
      };
    case appliancesConstants.DETAIL_SUCCESS:
      return {
        ...state,
        fetchingDetail: false,
        detail: action.detail
      };

    case appliancesConstants.DETAIL_FAILURE:
      return { ...state };
    case appliancesConstants.SET_TAB:
      return {
        ...state,
        tab: action.tab,
        fetchingDetail: true,
        detailItem: "0"
      };
    case appliancesConstants.SET_DETAIL_ITEM:
      return {
        ...state,
        detailItem: action.timestamp
      };
    default:
      return state;
  }
}
